import React, { useMemo } from 'react';
import './sideFilterStars.less';
import { Checkbox, Skeleton } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import {
  updateModalSideFilters,
  updateSiteFilter,
} from '../../../../modules/SearchDatePicker/searchDatePickerSlice';
import { AiFillStar } from 'react-icons/ai';
import { StarsFilter } from '../../interface';
import useGetAttributeTranslation from '../../hooks/useGetAttributeTranslation';
import { addToCurrencyString, roundUpCurrency } from '@skygroup/shared/utils/roundUpCurrency';

interface Props {
  filter: StarsFilter;
  starsGreaterThanRatingFilter?: boolean;
  withModalScopeParams?: boolean;
  isLoading?: boolean;
  additionalPrice?: number;
  localSideFilters?: Record<string, any> | null;
  setLocalSideFilters?: (f: Record<string, any>) => void;
}
const SideFilterStars = ({
  filter,
  starsGreaterThanRatingFilter,
  withModalScopeParams,
  isLoading,
  additionalPrice = 0,
  localSideFilters,
  setLocalSideFilters
}: Props) => {
  const dispatch = useDispatch();
  const { sideFilters: reduxSideFilters, modalSideFilters } = useSelector(
    (state: RootState) => {
      return state.search;
    }
  );
  const sideFilters = useMemo(
    () => (localSideFilters ? localSideFilters : withModalScopeParams ? modalSideFilters : reduxSideFilters),
    [withModalScopeParams, modalSideFilters, reduxSideFilters, localSideFilters]
  );
  // helper that updates either local filters (if provided) or redux
  const commitFilter = (key: string, value: any) => {
    if (setLocalSideFilters) {
      // update local copy immutably
      setLocalSideFilters({
        ...(localSideFilters || {}),
        [key]: value,
      });
      return;
    }
    const fn = withModalScopeParams ? updateModalSideFilters : updateSiteFilter;
    dispatch(fn({ key: filter.attr, value: value }));
  };



  const handleChange = (newValue: string[]) => {
    commitFilter(filter.attr, newValue);
  };

  const { general: t } = useSelector(
    (state: RootState) => state.config.translations
  );
  const attributeTranslation = useGetAttributeTranslation();

  if (isLoading) {
    return <Skeleton active paragraph={{ rows: 1 }} />;
  }

  return (
    <div className="side-filter-star">
      <h2>{attributeTranslation(filter.attr)}</h2>
      <Checkbox.Group
        className="check-box-group"
        options={filter.options
          .filter((option) => option.id !== null && option.id !== undefined)
          .map((option) => {
            return {
              label: (
                <div>
                  <div className="label-name">
                    {' '}
                    {option.id === 0
                      ? t.noRating
                      : Array.from({ length: option.id }).map((_, i) => {
                          return (
                            <AiFillStar key={i} size={20} color="#2d2d2d" />
                          );
                        })}
                    {starsGreaterThanRatingFilter ? '+' : ''}
                  </div>
                  {option?.min && (
                    <div className="price">
                      {t.minPrice} <b>{roundUpCurrency(addToCurrencyString(option.min, additionalPrice))}</b>
                    </div>
                  )}
                </div>
              ),
              value: option.id,
            };
          })}
        onChange={(e: any) => handleChange(e)}
        value={(sideFilters?.[filter.attr] ?? []).filter((v: any) => v !== null && v !== undefined)}
      ></Checkbox.Group>
    </div>
  );
};

export default SideFilterStars;
